import { useCallback, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import axios, { API, authed, errMsg } from "../../lib/api";

const ROLE_LABEL = { admin: "Administrator", member: "Fără acces" };

export const UsersAdmin = ({ me }) => {
  const { getToken } = useAuth();
  const [data, setData] = useState({ roles: [], users: [] });

  const load = useCallback(async () => {
    const r = await axios.get(`${API}/users`, await authed(getToken));
    setData(r.data);
  }, [getToken]);
  useEffect(() => { load(); }, [load]);

  const change = async (u, role) => {
    try {
      await axios.patch(`${API}/users/${u.user_id}/role`, { role }, await authed(getToken));
      toast.success("Rolul a fost actualizat.");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <p className="mb-5 max-w-xl text-sm text-slate-400">
        Colegii își creează cont din „Panou Manager”. Apoi apar aici și le poți da rolul de Administrator.
      </p>
      <ul className="space-y-3" data-testid="admin-users-list">
        {data.users.map((u) => (
          <li key={u.user_id} data-testid={`admin-user-row-${u.user_id}`} className="flex items-center justify-between gap-3 rounded-2xl border border-white/[0.07] bg-[#131B26] p-4">
            <div className="min-w-0">
              <p className="truncate font-medium">{u.name || u.email || u.user_id}</p>
              <p className="truncate text-xs text-slate-500">{u.name ? u.email : ""}{u.user_id === me.user_id ? `${u.name ? " · " : ""}tu` : ""}</p>
            </div>
            <Select value={u.role} onValueChange={(v) => change(u, v)}>
              <SelectTrigger className="w-40" data-testid={`admin-user-role-${u.user_id}`}><SelectValue /></SelectTrigger>
              <SelectContent>
                {data.roles.map((r) => <SelectItem key={r} value={r} data-testid={`role-option-${r}`}>{ROLE_LABEL[r] || r}</SelectItem>)}
              </SelectContent>
            </Select>
          </li>
        ))}
      </ul>
    </div>
  );
};
